module.exports = __webpack_public_path__ + "static/assets/51a75dd50afd0bc6022dfc86455be19c.mp3";